module.exports = __webpack_public_path__ + "img/result-banner.1d2780dc.jpg";